import styled from 'styled-components';

export const AgentChatStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  position: relative;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  align-self: center;

  .btn-back {
    width: 150px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 14px;
    line-height: 17px;
    border-radius: 10px;
    padding: 10px;
    margin: 0 0 20px;
    border: 1px solid rgba(157, 157, 157, 0.4);
    background: var(--gray-100);
  }

  .ideas-wrap {
    width: 100%;
    margin: 0 0 20px;

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
      margin: 0 0 20px;
      color: var(--light-gray);

      @media screen and (min-width: 768px) {
        align-items: center;
        font-size: 20px;
        line-height: 24px;
      }
    }
  }
`;

export const DeepSearhCol = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 30px 20px 20px;
  margin: 0 0 20px;
  border-radius: 20px;
  border: 1px solid rgba(157, 157, 157, 0.3);
  background: var(--white);

  .img-box {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 10px;
    background: rgba(26, 42, 108, 0.2);
  }

  .text-box {
    flex-grow: 1;

    .title {
      display: block;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      text-transform: capitalize;
      margin: 0 0 5px;
    }

    p {
      margin: 0 0 10px;
    }

    .learn-more {
      display: inline-block;
      font-size: 14px;
      line-height: 17px;
      color: var(--light-gray);
    }
  }

  .btn-export {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: var(--gray-100);
  }
`;

export const IdeasWrap = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 15px;
  margin: 0 0 20px;

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .idea-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    text-align: left;
    width: 100%;
    min-height: 150px;
    padding: 15px;
    font-size: 16px;
    line-height: 20px;
    border-radius: 20px;
    color: var(--text-color);
    border: 1px solid rgba(157, 157, 157, 0.3);
    background: var(--white);

    .title {
      display: block;
      flex-grow: 1;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      margin: 0 0 5px;
      color: var(--text-color);
    }

    .ico-arrow {
      align-self: flex-end;
      font-size: 20px;
      line-height: 1;
    }
  }
`;
